export default "__VITE_ASSET__BOwmnaxo__"